import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { DepositosController } from './depositos.controller';
import { DepositosService } from './depositos.service';

@Module({
  imports: [PrismaModule],
  controllers: [DepositosController],
  providers: [DepositosService],
  exports: [DepositosService],
})
export class DepositosModule {}
